import { render } from "./LearningPlansApp.vue?vue&type=template&id=6885c03b"
import script from "./LearningPlansApp.vue?vue&type=script&lang=js"
export * from "./LearningPlansApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__